import React, { useState, useEffect } from "react";

const allQuestions = [
  {
    question: "Question 1: Build the Online Shop System 🛒",
    structure: [
      { level: 1, items: [{ accept: "shop", label: "Online Shop" }] },
      {
        level: 2,
        items: [
          { accept: "frontend", label: "Front Part" },
          { accept: "backend", label: "Inside Part" },
          { accept: "admin", label: "Helper Part" },
        ],
      },
    ],
    choices: [
      { id: "user-accounts", label: "User Accounts", target: "frontend" },
      { id: "product-catalog", label: "Product List", target: "frontend" },
      { id: "shopping-cart", label: "Shopping Cart", target: "frontend" },
      { id: "payment-system", label: "Payment", target: "backend" },
      { id: "order-management", label: "Orders", target: "backend" },
      { id: "notifications", label: "Messages", target: "admin" },
      { id: "admin-panel", label: "Admin Room", target: "admin" },
    ],
  },
  {
    question: "Question 2: Build a School Management System 🏫",
    structure: [
      { level: 1, items: [{ accept: "school", label: "School" }] },
      {
        level: 2,
        items: [
          { accept: "students", label: "Student Section" },
          { accept: "teachers", label: "Teacher Section" },
          { accept: "office", label: "Office Section" },
        ],
      },
    ],
    choices: [
      { id: "attendance", label: "Attendance", target: "students" },
      { id: "grades", label: "Grades", target: "students" },
      { id: "classroom", label: "Classroom", target: "teachers" },
      { id: "homework", label: "Homework", target: "teachers" },
      { id: "fees", label: "Fee Management", target: "office" },
      { id: "notices", label: "Notices", target: "office" },
    ],
  },
  {
    question: "Question 3: Build a Zoo Management System 🦁",
    structure: [
      { level: 1, items: [{ accept: "zoo", label: "Zoo" }] },
      {
        level: 2,
        items: [
          { accept: "animals", label: "Animal Area" },
          { accept: "visitors", label: "Visitor Area" },
          { accept: "staff", label: "Staff Area" },
        ],
      },
    ],
    choices: [
      { id: "lions", label: "Lions", target: "animals" },
      { id: "birds", label: "Birds", target: "animals" },
      { id: "tickets", label: "Ticket Counter", target: "visitors" },
      { id: "cafeteria", label: "Cafeteria", target: "visitors" },
      { id: "cleaning", label: "Cleaning Team", target: "staff" },
      { id: "security", label: "Security", target: "staff" },
    ],
  },
  {
    question: "Question 4: Build a Hospital System 🏥",
    structure: [
      { level: 1, items: [{ accept: "hospital", label: "Hospital" }] },
      {
        level: 2,
        items: [
          { accept: "patients", label: "Patient Area" },
          { accept: "doctors", label: "Doctor Section" },
          { accept: "admin", label: "Admin Office" },
        ],
      },
    ],
    choices: [
      { id: "ward", label: "Ward", target: "patients" },
      { id: "pharmacy", label: "Pharmacy", target: "patients" },
      { id: "surgeon", label: "Surgeon", target: "doctors" },
      { id: "nurse", label: "Nurse", target: "doctors" },
      { id: "records", label: "Medical Records", target: "admin" },
      { id: "billing", label: "Billing", target: "admin" },
    ],
  },
  {
    question: "Question 5: Build a Computer System 💻",
    structure: [
      { level: 1, items: [{ accept: "computer", label: "Computer" }] },
      {
        level: 2,
        items: [
          { accept: "hardware", label: "Hardware" },
          { accept: "software", label: "Software" },
        ],
      },
    ],
    choices: [
      { id: "monitor", label: "Monitor", target: "hardware" },
      { id: "keyboard", label: "Keyboard", target: "hardware" },
      { id: "processor", label: "Processor", target: "hardware" },
      { id: "os", label: "Operating System", target: "software" },
      { id: "app", label: "Applications", target: "software" },
      { id: "browser", label: "Web Browser", target: "software" },
    ],
  },
  {
    question: "Question 6: Build a Website System 🌐",
    structure: [
      { level: 1, items: [{ accept: "website", label: "Website" }] },
      {
        level: 2,
        items: [
          { accept: "frontend", label: "Front-End" },
          { accept: "backend", label: "Back-End" },
          { accept: "database", label: "Database" },
        ],
      },
    ],
    choices: [
      { id: "html", label: "HTML & CSS", target: "frontend" },
      { id: "js", label: "JavaScript", target: "frontend" },
      { id: "server", label: "Server Logic", target: "backend" },
      { id: "api", label: "APIs", target: "backend" },
      { id: "sql", label: "SQL Tables", target: "database" },
      { id: "data", label: "Stored Data", target: "database" },
    ],
  },
];

const styles = {
  body: {
    fontFamily: "'Fredoka One', cursive",
    background: "linear-gradient(to bottom, #b2f2ff 0%, #e3f6ff 100%)",
    backgroundImage:
      "url('https://cdn.pixabay.com/photo/2020/10/23/08/58/landscape-5679427_1280.png')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    color: "#333",
    textAlign: "center",
    margin: 0,
    padding: 20,
    minHeight: "100vh",
  },
  h1: { color: "#ff6f61", fontSize: "2.3em", textShadow: "3px 3px #fff" },
  p: { color: "#333", fontSize: 16, marginBottom: 10 },
  diagram: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 20,
    background: "rgba(255, 255, 255, 0.9)",
    border: "4px solid #ffd166",
    borderRadius: 25,
    padding: 25,
    boxShadow: "0 8px 12px rgba(0,0,0,0.15)",
  },
  level: { display: "flex", justifyContent: "center", gap: 25, margin: "20px 0", flexWrap: "wrap" },
  dropzone: {
    border: "3px dashed #90caf9",
    borderRadius: 15,
    background: "#fff",
    minHeight: 70,
    width: 160,
    padding: 12,
    textAlign: "center",
    fontSize: 16,
    color: "#555",
    transition: "0.3s",
    cursor: "pointer",
  },
  choices: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 15,
    background: "#ffd166",
    borderRadius: 20,
    padding: 20,
    marginTop: 30,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  choice: {
    background: "#ff6f61",
    color: "#fff",
    borderRadius: 15,
    padding: "10px 15px",
    cursor: "grab",
    fontSize: 16,
    transition: "transform 0.2s, background 0.3s",
    boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
  },
  buttons: {
    margin: 10,
    padding: "10px 18px",
    border: "none",
    background: "#06d6a0",
    color: "#fff",
    fontSize: 16,
    borderRadius: 12,
    cursor: "pointer",
    transition: "0.3s",
    boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
  },
};

export default function CartoonHierarchyGame() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [dropZones, setDropZones] = useState({});
  const [choicesState, setChoicesState] = useState({});

  useEffect(() => loadQuestion(currentQuestion), [currentQuestion]);

  const loadQuestion = (index) => {
    const q = allQuestions[index];
    const zones = {};
    const choices = {};
    q.structure.forEach((lvl) =>
      lvl.items.forEach((item) => {
        zones[item.accept] = { label: item.label, filled: false, correct: false };
      })
    );
    q.choices.forEach((c) => (choices[c.id] = { ...c, correct: false, disabled: false }));
    setDropZones(zones);
    setChoicesState(choices);
  };

  const handleDrop = (e, acceptKey) => {
    e.preventDefault();
    const choiceId = e.dataTransfer.getData("choiceId");
    if (!choiceId) return;
    const choice = choicesState[choiceId];
    if (!choice) return;

    if (acceptKey === choice.target) {
      setDropZones((prev) => ({
        ...prev,
        [acceptKey]: { ...prev[acceptKey], filled: true, correct: true, label: prev[acceptKey].label + " | " + choice.label },
      }));
      setChoicesState((prev) => ({ ...prev, [choiceId]: { ...prev[choiceId], correct: true, disabled: true } }));
    } else alert("❌ Wrong place!");
  };

  const allowDrop = (e) => e.preventDefault();

  const resetQuestion = () => loadQuestion(currentQuestion);

  const showAnswers = () => {
    const q = allQuestions[currentQuestion];
    const zones = {};
    q.structure.forEach((lvl) =>
      lvl.items.forEach((item) => {
        const answers = q.choices.filter((c) => c.target === item.accept).map((c) => c.label);
        zones[item.accept] = { label: answers.join(" | "), filled: true, correct: true };
      })
    );
    setDropZones(zones);
    const updatedChoices = {};
    q.choices.forEach((c) => (updatedChoices[c.id] = { ...c, disabled: true, correct: true }));
    setChoicesState(updatedChoices);
  };

  const nextQuestion = () => {
    if (currentQuestion < allQuestions.length - 1) setCurrentQuestion(currentQuestion + 1);
    else alert("🎉 Amazing job! You completed all 6 cartoon hierarchy systems!");
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>🎨 Cartoon Hierarchy Builder!</h1>
      <p style={styles.p}>{allQuestions[currentQuestion].question}</p>

      <div style={styles.diagram}>
        {allQuestions[currentQuestion].structure.map((lvl, idx) => (
          <div key={idx} style={styles.level}>
            {lvl.items.map((item) => (
              <div
                key={item.accept}
                onDrop={(e) => handleDrop(e, item.accept)}
                onDragOver={allowDrop}
                style={{
                  ...styles.dropzone,
                  background: dropZones[item.accept]?.filled ? "#b8f2e6" : "#fff",
                  borderColor: dropZones[item.accept]?.filled ? "#06d6a0" : "#90caf9",
                  color: dropZones[item.accept]?.filled ? "#222" : "#555",
                }}
              >
                {dropZones[item.accept]?.label || item.label}
              </div>
            ))}
          </div>
        ))}
      </div>

      <div style={styles.choices}>
        {Object.values(choicesState).map((c) => (
          <div
            key={c.id}
            draggable={!c.disabled}
            onDragStart={(e) => e.dataTransfer.setData("choiceId", c.id)}
            style={{
              ...styles.choice,
              opacity: c.disabled ? 0.5 : 1,
              cursor: c.disabled ? "not-allowed" : "grab",
            }}
          >
            {c.label}
          </div>
        ))}
      </div>

      <div>
        <button style={styles.buttons} onClick={resetQuestion}>🔄 Reset</button>
        <button style={styles.buttons} onClick={showAnswers}>💡 Show Answers</button>
        <button style={{ ...styles.buttons, background: "#ffd166", color: "#333" }} onClick={nextQuestion}>Next ➡️</button>
      </div>
    </div>
  );
}